import { createReducer, on } from '@ngrx/store';
import * as actions from './settings.actions';
import { initialState } from '../auth.state';

export const authSettingsReducer = createReducer(
  initialState,
  on(actions.RequestCreateSettingsFlow, (state) => ({ ...state, loading: true })),
  on(actions.SuccessCreateSettingsFlow, (state, { flow }) => ({
    ...state,
    loading: false,
    settingsFlow: flow,
  })),
  on(actions.FailCreateSettingsFlow, (state, { error }) => ({ ...state, loading: false, error })),

  on(actions.RequestUpdateSettingsFlow, (state) => ({ ...state, loading: true })),
  on(actions.SuccessUpdateSettingsFlow, (state, { flow }) => ({
    ...state,
    loading: false,
    settingsFlow: flow,
  })),
  on(actions.FailUpdateSettingsFlow, (state, { error, flow }) => ({
    ...state,
    loading: false,
    error,
    settingsFlow: flow,
  })),

  on(actions.RequestChangePasswordAction, (state) => ({ ...state, loading: true })),
  on(actions.ResponseSuccessChangePasswordAction, (state) => ({
    ...state,
    loading: false,
    error: '',
    passwordChangeFlow: 'COMPLETE' as 'COMPLETE',
    passwordChangeFlowId: null,
  })),
  on(actions.ResponseFailChangePasswordAction, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(actions.BeginPasswordChange, (state) => ({
    ...state,
    passwordChangeFlow: 'IN_PROGRESS' as 'IN_PROGRESS',
  }))
);
